import { render, staticRenderFns } from "./HRiseNews.vue?vue&type=template&id=f7998a9a&scoped=true&"
import script from "./HRiseNews.vue?vue&type=script&lang=js&"
export * from "./HRiseNews.vue?vue&type=script&lang=js&"
import style0 from "./HRiseNews.vue?vue&type=style&index=0&id=f7998a9a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7998a9a",
  null
  
)

export default component.exports